module.exports = __webpack_public_path__ + "img/logo-Eisai_03.efea9712.png";